import { render, staticRenderFns } from "./torniquete.vue?vue&type=template&id=48207c64&scoped=true&"
import script from "./torniquete.vue?vue&type=script&lang=js&"
export * from "./torniquete.vue?vue&type=script&lang=js&"
import style0 from "./torniquete.vue?vue&type=style&index=0&id=48207c64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48207c64",
  null
  
)

export default component.exports